import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 0.75rem;
  border-radius:5px 5px 0 0;
  border-bottom: 1px solid rgba(121, 121, 121, 0.75);
  transition: background-color 0.3s;
  cursor: pointer;

  &:hover {
    background-color: #16a34a6c;
  }
`;

export const NameStatus = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;
`;

export const DriverName = styled.span`
  font-weight: 600;
  color: black;
`;

export const DriverStatus = styled.span`
  font-size: 1rem;
  color: ${(props) =>
    props.status === "اونلاين"
      ? "#16a34a"
      : props.status === "في الرحلة"
      ? "rgb(29, 178, 194)"
      : "rgb(239, 144, 27)"};
`;
